<template>
  <v-layout
    id="lsm-edit-form"
    justify-center
    wrap
  >
    <v-flex
      xs12
      md8
      lg8
    >
      <h2 v-if="!course">
        {{ $t('modules.coursesNew') }}
      </h2>
      <h2 v-else>
        {{ $t('modules.coursesEdit') }}
      </h2>
      <v-tabs :value="active_tab">
        <v-tab
          v-for="(n,i) in [$t('modules.course'), $t('modules.courseTabLessons'), $t('modules.courseTabFiles')]"
          :key="i"
          :disabled="!course && !courseCreated"
          @change="active_tab = i"
        >
          {{ n }} 
        </v-tab>
      </v-tabs>
      <v-card class="pt-7 pl-5 pr-5">
        <v-form id="course-form">
          <course-label-form 
            v-show="active_tab === 0"
            ref="tab0"
            :course="course"
            :whitelabel-uuid="whitelabelUuid"
            :course-uuid="courseUuid"
            @closeCourseForm="closeCourseForm"
            @nextStep="nextStep"
          />
          <lectures-label
            v-show="active_tab === 1"
            ref="tab1"
            :course="course"
            :course-uuid="courseUuid"
            :course-id="courseId"
            :whitelabel-uuid="whitelabelUuid"
            @nextStep="nextStep"
            @closeCourseForm="closeCourseForm"
            @handledIsOpenForm="handledIsOpenForm"
          />
          <files-label
            v-show="active_tab === 2"
            ref="tab2"
            :course="course"
            :course-uuid="courseUuid"
            :course-id="courseId"
            :whitelabel-uuid="whitelabelUuid"
            @nextStep="nextStep"
            @closeCourseForm="closeCourseForm"
            @handledIsOpenForm="handledIsOpenForm"
          />  
          <v-divider v-if="active_tab !== 0 && !isOpenEditForm" />        
          <v-layout v-if="active_tab !== 0 && !isOpenEditForm">
            <v-flex
              xs12
              class="text-right"
            >
              <v-btn
                outlined                
                @click="$emit('closeEditMode', courseCreated)"
              >
                {{ $t('modules.courseClose') }}
              </v-btn>
            </v-flex>
          </v-layout> 
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CourseLabelForm from './partial/CourseLabelForm.vue';
import LecturesLabel from './partial/LecturesLabel/List.vue';
import FilesLabel from './partial/FilesLabel/List.vue';

export default {
  name: "ModuleCourseEditForm",
  components: {
    CourseLabelForm,
    LecturesLabel,
    FilesLabel
  },
  props: {
    course: {
      type: Object,
      default: null
    },
    whitelabelUuid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      active_tab: 0,
      loading: false,
      isOpenEditForm: false,
      courseUuid: '',
      courseId: '',
      courseCreated: false
    }
  },
  mounted() {
    if(this.course) this.courseUuid = this.course.uuid;
    if(this.course) this.courseId = this.course.id;
  },
  methods: { 
    closeCourseForm(isClose) {
      this.$emit('closeEditMode', isClose);
    },
    handledIsOpenForm(isVal){
      this.isOpenEditForm = isVal;
    },
    isLoading(isLoading) {
      this.loading = isLoading;
    },
    nextStep(course) {
      this.active_tab += 1;
      this.courseUuid = course.uuid;
      this.courseId = course.id;
      this.courseCreated = true;
    },
  }
}
</script>

<style lang="scss">
</style>
